"use strict";
/*
 * Copyright (C) 2018 Spanning Cloud Apps.  All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertRuleObjectState = void 0;
var AlertRuleObjectState;
(function (AlertRuleObjectState) {
    AlertRuleObjectState["ADDED"] = "added";
    AlertRuleObjectState["DELETED"] = "deleted";
    AlertRuleObjectState["UPDATED"] = "updated";
})(AlertRuleObjectState || (exports.AlertRuleObjectState = AlertRuleObjectState = {}));
//# sourceMappingURL=AlertRuleObjectState.js.map